// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"b0ea0b1f","197":"b0ea0b1f","449":"b0ea0b1f","613":"b0ea0b1f","636":"a90d158c"}[chunkId] + ".chunk.css";
};